import React from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import {
  LayoutDashboard, Store, MapPin, QrCode, Tag, Ticket, Coins,
  Users, FileBarChart, MessageSquare, Activity, LogOut, ScrollText, Plug,
  Layers, FolderTree
} from "lucide-react";
import { useAuth } from "@/lib/auth";

const navItems = [
  { to: "/", icon: LayoutDashboard, label: "Dashboard" },
  { to: "/brands", icon: Store, label: "Brands" },
  { to: "/locations", icon: MapPin, label: "Locations" },
  { to: "/floors", icon: Layers, label: "Floors" },
  { to: "/categories", icon: FolderTree, label: "Categories" },
  { to: "/qrcodes", icon: QrCode, label: "QR Codes" },
  { to: "/offers", icon: Tag, label: "Offers" },
  { to: "/vouchers", icon: Ticket, label: "Vouchers" },
  { to: "/loyalty", icon: Coins, label: "Loyalty Rules" },
  { to: "/customers", icon: Users, label: "Customers" },
  { to: "/bills", icon: ScrollText, label: "Bills" },
  { to: "/whatsapp", icon: MessageSquare, label: "WhatsApp" },
  { to: "/karix", icon: Plug, label: "Karix Setup" },
  { to: "/reports", icon: FileBarChart, label: "Reports" },
  { to: "/analytics", icon: Activity, label: "Analytics" },
  { to: "/users", icon: Users, label: "Users", role: ["super_admin"] },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const loc = useLocation();

  return (
    <aside className="bg-[#1A1A1A] text-white w-[260px] min-h-screen flex flex-col" data-testid="sidebar">
      {/* Client logo top-left */}
      <div className="px-6 py-7 border-b border-white/5 flex items-center gap-3">
        <img src="/brand/gulshan-logo.jpg" alt="Gulshan ONE29" className="h-11 w-auto object-contain shrink-0" />
        <div className="min-w-0">
          <div className="text-[15px] font-light tracking-wide truncate" style={{ fontFamily: "Outfit" }}>Gulshan ONE29</div>
          <div className="label-tiny truncate" style={{ color: "rgba(255,255,255,0.4)" }}>Mall Loyalty</div>
        </div>
      </div>

      <nav className="py-5 flex-1 overflow-y-auto">
        {navItems.map((item) => {
          if (item.role && (!user || !item.role.includes(user.role))) return null;
          const Icon = item.icon;
          const active = item.to === "/" ? loc.pathname === "/" : loc.pathname.startsWith(item.to);
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={`sidebar-link ${active ? "active" : ""}`}
              data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <Icon size={16} strokeWidth={1.5} />
              <span>{item.label}</span>
            </NavLink>
          );
        })}
      </nav>

      <div className="px-6 py-5 border-t border-white/5">
        {user && (
          <div className="mb-4">
            <div className="label-tiny" style={{ color: "rgba(255,255,255,0.4)" }}>Signed in as</div>
            <div className="text-sm mt-1">{user.name}</div>
            <div className="text-[11px] text-white/40">{user.role.replace("_", " ")}</div>
          </div>
        )}
        <button onClick={logout} className="sidebar-link w-full" style={{ padding: "8px 0" }} data-testid="logout-btn">
          <LogOut size={14} strokeWidth={1.5} /> Sign out
        </button>
        <div className="mt-6 pt-4 border-t border-white/5 flex items-center gap-2">
          <span className="label-tiny" style={{ color: "rgba(255,255,255,0.4)" }}>Powered by</span>
          <img src="/brand/fundle-logo.png" alt="Fundle" className="h-3.5 object-contain" />
        </div>
      </div>
    </aside>
  );
}
